import L from 'leaflet';

export const mapsTile = {
  'Open Street Map': L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a>',
  }),
  'Эко Рельеф': L.tileLayer.wms('http://gis.esimo.ru/eko/eko/wms?service=WMS', {
    format: 'image/png',
    layers: 'eko_merge',
    version: '1.3.0',
    transparent: true,
    attribution: 'Рельеф',
  }),
  'Эко Бланк': L.tileLayer.wms('http://gis.esimo.ru/eko/eko/wms?service=WMS', {
    format: 'image/png',
    layers: 'eko_blank',
    version: '1.3.0',
    transparent: true,
    attribution: 'Бланк',
  }),
};

export const mapsLayers = {
  'УГМС Регионы': L.tileLayer.wms('http://gis.esimo.ru/eko/ASYNP/wms?service=WMS', {
    format: 'image/png',
    layers: 'ASYNP:ugms_region_2018',
    version: '1.3.0',
    transparent: true,
    attribution: 'ASYNP:ugms_region_2018',
    opacity: 0.35,
  }),
  'Субъекты Федерации': L.tileLayer.wms('http://gis.esimo.ru/eko/ASYNP/wms?service=WMS', {
    format: 'image/png',
    layers: 'ASYNP:admpol1000_obl_oktmo',
    version: '1.3.0',
    transparent: true,
    attribution: 'ASYNP:admpol1000_obl_oktmo',
    opacity: 0.35,
  }),
};

export type MapsTile = keyof typeof mapsTile;
export type MapsLayer = keyof typeof mapsLayers
